import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import R from 'ramda';

const UserInfo = props => {
  const {
    editUserInfo,
    firstName,
    lastName,
    email,
  } = props;

  const fields = [
    {
      label: 'First Name',
      value: 'firstName',
    },
    {
      label: 'Last Name',
      value: 'lastName',
    },
    {
      label: 'Email',
      value: 'email',
    },
  ];

  return (
    <div>
      {
        fields.map((field, i) => (
          <div key={i} style={{ width: '100%' }}>
            <div style={{ display: 'inline-block', width: '20%' }}>
              {field.label}:
            </div>
            <div style={{ display: 'inline-block', width: '70%' }}>
              <TextField
                id={field.value}
                fullWidth
                value={R.call(R.cond([
                  [R.equals('firstName'), R.always(firstName)],
                  [R.equals('lastName'), R.always(lastName)],
                  [R.equals('email'), R.always(email)],
                  [R.T, R.always('')],
                ]), field.value)}
                onChange={({ target: { value } }) => editUserInfo({ [field.value]: value.trim() })}
              />
            </div>
          </div>
        ))
      }
    </div>
  );
};

UserInfo.propTypes = {
  editUserInfo: PropTypes.func,
  userInfo: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/newUser/userInfo.jsx